import React, { Component } from 'react';
import * as actions from "../../Actions/xpa";
import { connect } from "react-redux";
import moment from 'moment';
import css from './xpa.css';
import LedgerForm from './LedgerForm';
import LinearProgress from '@material-ui/core/LinearProgress';

const data = {};
class XpaContainer extends Component {

    componentWillMount() {
        if (this.props.location.search.length > 10) {
           const queryData = JSON.parse('{"' + decodeURIComponent(this.props.location.search)
           .replace('?', '')
           .replace(/"/g, '\\"')
           .replace(/&ledger/g, '","ledger')
           .replace(/&entitytype/g, '","entitytype')
           .replace(/&cognitotoken/g, '","cognitotoken')
           .replace(/&finDate/g, '","finDate')
           .replace(/&region/g, '","region')
           .replace(/=/g,'":"') + '"}')
           Object.keys(queryData).forEach(item => data[item.toLowerCase()] = queryData[item]);
           if (data.cognitotoken) localStorage.setItem('cognitotoken', data.cognitotoken);
       }
     }

    addLedger = (values) => {
        const data = {
            region: (typeof values.region === 'string') ? values.region : values.region.value,
            bookName: values.bookName,
            firstTransactionDate: moment().add(-1, 'year').unix(),
            financialYearStartDay: (typeof values.financialYearStartDay === 'number') ? values.financialYearStartDay : values.financialYearStartDay.value,
            financialYearStartMonth: (typeof values.financialYearStartMonth === 'number') ? values.financialYearStartMonth : values.financialYearStartMonth.value
        }
        this.props.addLedger(data, this.props.history, <LinearProgress classes={css.loadingHeight} />); 
    }

    render() {
        const initialValues = {
            region: (data.region === '64') ? 'NZ' : 'AU',
            bookName: data.ledger || '',
            entityType: data.entitytype || '',
            financialYearStartDay: data.findate ? moment(data.findate, 'DD-MM-YYYY').format('D')*1 : 1,
            financialYearStartMonth: data.findate ? moment(data.findate, 'DD-MM-YYYY').format('M')*1 : 7,
          }

        return (
            <div>
                <div className={[css.width800, css.center].join(' ')}>
                    <h4 className={css.spaceLeft15}>Add Feed Collection</h4>
                    <div className={css.borderBox}>
                        <LedgerForm onSubmit={this.addLedger} initialValues={initialValues}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, actions)(XpaContainer);


// WEBPACK FOOTER //
// ./src/components/XPA/AddLedger.js